import { useTranslation } from 'react-i18next';
import { mdiWebhook } from '@mdi/js';
import { Box, Typography } from '@mui/material';

import { ILinkModuleListItemFragment } from 'graphql/types';
import { TTrainingModuleProps } from 'training/types';
import { Link } from 'common/components/Link';
import { Icon } from 'common/components/Icon';
import { ListFooter } from 'common/components/ListFooter';
import { ActionButton } from 'common/components/ActionButton';

export const AfasWebhookModule = ({
    id,
    trainingId,
}: TTrainingModuleProps<ILinkModuleListItemFragment>) => {
    const [translate] = useTranslation();

    return (
        <ListFooter
            disableHover
            component={Link}
            params={{
                trainingId,
                moduleId: id,
                type: 'afasTrigger',
            }}
            sx={{
                backgroundColor: 'grey.100',
            }}
            to="TRAINING_UPDATE_MODULE"
        >
            <ActionButton outlined aria-labelledby="afasTrigger" size="medium">
                <Icon path={mdiWebhook} size="2.4rem" />
            </ActionButton>
            <Box sx={{ ml: 2 }}>
                <Typography id="afasTrigger">
                    {translate('afasTrigger')}
                </Typography>
            </Box>
        </ListFooter>
    );
};
